/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceAssignmentMode } from './resourceAssignmentMode';


export interface TenantOrgCapabilitiesResource { 
    cbc_assignment_mode?: ResourceAssignmentMode;
    cbc_onprem_assignment_mode?: ResourceAssignmentMode;
    cws_assignment_mode?: ResourceAssignmentMode;
    cws_onprem_assignment_mode?: ResourceAssignmentMode;
    gcve_assignment_mode?: ResourceAssignmentMode;
    vmca_assignment_mode?: ResourceAssignmentMode;
    evs_assignment_mode?: ResourceAssignmentMode;
    cws_byo_allowed?: boolean;
    cws_onprem_byo_allowed?: boolean;
    evs_byo_allowed?: boolean;
    gcve_byo_allowed?: boolean;
    cbc_byo_allowed?: boolean;
    cbc_onprem_byo_allowed?: boolean;
    /**
     * Enable/Disable approval required for gcve assign operation
     */
    gcve_sddc_assignment_approval_required?: boolean;
    /**
     * Enable/Disable approval required for vmca assign operation
     */
    vmca_sddc_assignment_approval_required?: boolean;
    /**
     * Enable/Disable approval required for evs assign operation
     */
    evs_sddc_assignment_approval_required?: boolean;
}
export namespace TenantOrgCapabilitiesResource {
}


